/*
1. 攝影棚
2. 忠孝復興捷運站附近，固定2組
3. 行天宮捷運站附近，固定2組
* */

const newSpaceListQueryData = {
    "pagination": {
        "dir": 1,
        "limit": 20,
        "page": 1,
        "sort": "created_date"
    }
}

const photoStudio = {
    "pagination": {
        "dir": 0,
        "limit": 4,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        category_ids: {
            '2': [13]
        }
    }
}
const zhongxiaoFuxingStation1 = {
    "pagination": {
        "dir": 0,
        "limit": 4,
        "page": 1,
        "sort": "location"
    },
    filter_options: {
        "geo_search": {
            "longitude": 121.5394226856529,
            "latitude": 25.04064821708269,
            "width": 4000,
            "height": 4000
        }
    }
}

const hsingTianTempleStation1 = {
    "pagination": {
        "dir": 0,
        "limit": 4,
        "page": 1,
        "sort": "location"
    },
    filter_options: {
        "geo_search": {
            "longitude": 121.53321241516821,
            "latitude": 25.060117562272325,
            "width": 4000,
            "height": 4000
        }
    }
}

const trendSpaceListQueryDataList = [
    photoStudio,
    zhongxiaoFuxingStation1,
    hsingTianTempleStation1
]


const richerDaySpaceListQueryData = {
    "pagination": {
        "dir": 1,
        "limit": 20,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        keyword: '日富',
        "rent_time": {
            "rent_type": 0,
            "begin_time": "",
            "end_time": ""
        },
        "geo_search": {
            "longitude": 0,
            "latitude": 0,
            "width": 0,
            "height": 0,
            "radius": 0
        },
        "equipment_ids": [],
        "service_ids": [],
        "city_ids": [],
        "category_ids": {}
    }


}
const like268SpaceListQueryData = {
    "pagination": {
        "dir": 0,
        "limit": 20,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        keyword: '萊客共享空間',
        "rent_time": {
            "rent_type": 0,
            "begin_time": "",
            "end_time": ""
        },
        "geo_search": {
            "longitude": 0,
            "latitude": 0,
            "width": 0,
            "height": 0,
            "radius": 0
        },
        "equipment_ids": [],
        "service_ids": [],
        "city_ids": [],
        "category_ids": {}
    }


}
const trendDaySpaceListQueryData1 = {
    "pagination": {
        "dir": 1,
        "limit": 1,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        keyword: '毛時光'
    }
}
const trendDaySpaceListQueryData2 = {
    "pagination": {
        "dir": 1,
        "limit": 1,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        keyword: '社團法人NYCN國際美容美甲協會'
    }
}
const trendDaySpaceListQueryData3 = {
    "pagination": {
        "dir": 1,
        "limit": 1,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        keyword: 'POM共享商務空間'
    }
}
const trendDaySpaceListQueryData4 = {
    "pagination": {
        "dir": 1,
        "limit": 1,
        "page": 1,
        "sort": "created_date"
    },
    filter_options: {
        keyword: 'Dcar甜'
    }
}
const trendSpaceListQueryDataList2 = [
    trendDaySpaceListQueryData1,
    trendDaySpaceListQueryData2,
    trendDaySpaceListQueryData3,
    trendDaySpaceListQueryData4,
]


// 首頁新的拉空間資訊 space id /api/platform/main-page
// 0:熱門場地 1:萊客共享空間 2:日富空間
const spaceConfig = {
  dev: {
    trendSpaceIdList: [74634329007759, 38171887322908, 17217817985659, 81025333002559],
    like268SpaceIdList: [48662110473478, 95923901802410],
    richerDaySpaceIdList: [68466609295434]
  },
  prod: {
    trendSpaceIdList: [69677259741183, 97421272409397, 62383227199609, 55555143945341],
    like268SpaceIdList: [82944231792605, 28859960222829, 5587089343087, 65778944467729],
    richerDaySpaceIdList: [52850383724990, 52000247152702, 51381942043993, 50763246295391]
  }
}

const env = import.meta.env.VITE_ENV || 'dev'
const isDev = env === 'dev'

const { trendSpaceIdList, like268SpaceIdList, richerDaySpaceIdList } = spaceConfig[isDev ? 'dev' : 'prod']

export {
  newSpaceListQueryData,
  trendSpaceListQueryDataList,
  richerDaySpaceListQueryData,
  trendSpaceListQueryDataList2,
  like268SpaceListQueryData,
  trendSpaceIdList,
  richerDaySpaceIdList,
  like268SpaceIdList
}
